/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress, ListItemText } from '@material-ui/core';
// import { showNotification } from '../../App';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // minWidth: '200px',
        },
    }),
);

interface AffinityMatterTypeSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value: IAutoCompleteItem | IAutoCompleteItem[], name: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    disablePortal?: boolean;
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
    filter?: {
        category?: string;
        state?: string;
    };
}

export interface MatterTypeOptionProps extends MatterTypeOptionForAffinity, IAutoCompleteItem {}

interface AffinityMatterTypeSelectorState {
    isLoading: boolean;
    options: MatterTypeOptionProps[];
}

export const AffinityMatterTypeSelector: React.FC<AffinityMatterTypeSelectorProps> = (props) => {
    const classes = useStyles();

    const [state, setState] = useState<AffinityMatterTypeSelectorState>({
        isLoading: false,
        options: [],
    });

    const matterTypeQuery = useQuery<MatterTypeData>(MatterTypeQuery);

    useEffect(() => {
        if (!matterTypeQuery.loading && !matterTypeQuery.error && matterTypeQuery.data && matterTypeQuery.data.lookup && matterTypeQuery.data.lookup.matterTypeOptionForAffinity) {
            setState((prevState) => {
                const { matterTypeOptionForAffinity } = matterTypeQuery.data!.lookup;

                const filteredMatterType = matterTypeOptionForAffinity.map((source: MatterTypeOptionForAffinity) => ({ ...source, value: source.matterTypeId, label: source.description }));
                return {
                    ...prevState,
                    options: filteredMatterType,
                    isLoading: false,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [matterTypeQuery.loading, matterTypeQuery.error, matterTypeQuery.data, props.filter]);

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        // tslint:disable-next-line: no-console
        console.log('onChange', value);
        if (props.onSelection) {
            props.onSelection(value, props.name ? props.name : 'matterType');
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return {
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                    {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                </React.Fragment>
            ),
        };
    };

    const onOpen = () => {
        // matterTypeQuery.refetch();
    };

    // const getOptionsFiltered = () => {
    //     if (props.filter && props.filter.state && props.filter.category) {
    //         const tempOptions = state.options.filter(
    //             (value: MatterTypeOptionProps, index: number, array: MatterTypeOptionProps[]) =>
    //                 value.categoryId === props.filter!.category && value.state === props.filter!.state && index === array.findIndex((t) => t.id === value.id),
    //         );

    //         // const tempOptions = _.filter(state.options, {'categoryId': props.filter!.category, 'state':  props.filter!.state})

    //         return tempOptions;
    //     } else if (props.filter && props.filter.state && props.filter.category === undefined) {
    //         const tempOptions = state.options.filter(
    //             (value: MatterTypeOptionProps, index: number, array: MatterTypeOptionProps[]) =>
    //                 value.state === props.filter!.state && index === array.findIndex((t) => t.id === value.id),
    //         );

    //         return tempOptions;
    //     } else if (props.filter && props.filter.category && props.filter.state === undefined) {
    //         const tempOptions = state.options.filter(
    //             (value: MatterTypeOptionProps, index: number, array: MatterTypeOptionProps[]) =>
    //                 value.categoryId === props.filter!.category && index === array.findIndex((t) => t.id === value.id),
    //         );

    //         return tempOptions;
    //     } else {
    //         return state.options;
    //     }
    // };

    return (
        <div className={`${classes.root} ${props.className}`}>
            {props.multiple ? (
                <Autocomplete
                    value={props.value}
                    multiple={true}
                    loading={matterTypeQuery.loading}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    onOpen={onOpen}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    getOptionSelected={(option, value) => value.value === option.value}
                    onBlur={props.onBlur}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, matterTypeQuery.loading)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);

                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            ) : (
                <Autocomplete
                    value={props.value}
                    loading={matterTypeQuery.loading}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    onBlur={props.onBlur}
                    onOpen={onOpen}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, matterTypeQuery.loading)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);
                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            )}
        </div>
    );
};

export interface MatterTypeData {
    lookup: Lookup;
}

export interface Lookup {
    matterTypeOptionForAffinity: MatterTypeOptionForAffinity[];
}

export interface MatterTypeOptionForAffinity {
    matterTypeId: string;
    description: string;
}

export const MatterTypeQuery = gql`
    query MatterTypeOptionForAffinity {
        lookup {
            matterTypeOptionForAffinity {
                matterTypeId
                description
            }
        }
    }
`;
